import PlantList from './PlantList';

export default PlantList;